import axios from "axios";

//export const  API_URL = 'http://localhost:8080';
 export const  API_URL = 'https://api.xilliontech.in';

const api = axios.create({
    baseURL: `${API_URL}/api`,
    withCredentials: true,
});

export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common["Authorization"];
    }
};


// Attach token to every request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("jwtToken");// Get from storage
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default api